import { pick as _pick } from 'lodash';
import * as EmeraldErrorCodes from '../../common/helpers/error-code';
import { IMessageModal } from '../interfaces/dtos/IMessageModal';

export const DefaultEmeraldErrorMessage = 'Sorry. We encountered an unexpected error.';

export enum EmeraldErrorSeverity {
  Error = 'Error',
  Warning = 'Warning',
  Info = 'Info',
}

export interface IEmeraldError {
  code: string;
  message: string;
  severity: EmeraldErrorSeverity;
  data: any;
}

export class EmeraldError extends Error implements IEmeraldError {
  public constructor(code?: string, message?: string, severity?: EmeraldErrorSeverity, data?: any) {
    super();
    this.code = code ?? 'UnknownErrorCode';
    this.message = message ?? DefaultEmeraldErrorMessage;
    this.severity = severity ?? EmeraldErrorSeverity.Error;
    this.data = data;
  }
  public code: string;
  public severity: EmeraldErrorSeverity;
  public data: any;
}

export class EmeraldErrorModal extends EmeraldError {
  public constructor(errorModal: IMessageModal) {
    super();
    this.errorModal = errorModal;
    this.code = errorModal.message || 'EmeraldErrorModal';
  }
  public errorModal: IMessageModal;
}

export const parseEmeraldError = (error: any): IEmeraldError => {
  error = _pick(error, ['code', 'message', 'severity', 'data']);
  const emeraldError = new EmeraldError(
    error.code || EmeraldErrorCodes.MissingErrorCode,
    error.message,
    error.severity,
    error.data,
  );
  return emeraldError;
};

export const parseClientEmeraldErrors = (serverError: IEmeraldError): IEmeraldError => {
  let clientError;
  switch (serverError.code) {
    case EmeraldErrorCodes.IdmInvalidSession:
    case EmeraldErrorCodes.IdmSessionTimeout:
      clientError = getIdmInvalidSessionError();
      break;
  }

  const error = { ...serverError, ...clientError }; // Overide server values with client values
  const emeraldError = parseEmeraldError(error);
  return emeraldError;
};

//#region InvalidSession

export const getIdmInvalidSessionError = (): EmeraldError => {
  const error = new EmeraldError(
    EmeraldErrorCodes.SessionExpired,
    'Your session has expired. Please Login again to continue',
  );
  return error;
};

//#endregion
